var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-content',{class:[
        'md-primary',
        _vm.elevation ? 'md-elevation-'+_vm.elevation : undefined,
        {'md-scrollbar': _vm.isScrollbar,}
    ],style:({
        width: _vm.w ? _vm.w + 'px' : undefined,
        height: _vm.h ? _vm.h + 'px' : undefined,
        margin: _vm.m ? _vm.m + 'px' : undefined,
        padding: _vm.p ? _vm.p + 'px' : undefined,
        backgroundColor: _vm.colorBg,
        color: _vm.colorFg,
    }),attrs:{"md-tag":_vm.tag,"md-theme":_vm.isThInv ? _vm.th+'i' : _vm.th}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf2dd830","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/frame/vue/Frame.vue
// module id = cgvj
// module chunks = 8